import Entity from '../../utilities/entity';
import TrainingAttendance from './attendance';

class TrainingSessionLesson extends Entity {

    attendances() {
        return this.hasMany(TrainingAttendance);
    }

}

export default new TrainingSessionLesson();